"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../helpers/DeviceInfoHelper"));

var _DataStore = _interopRequireDefault(require("../../KESI2/Stores/DataStore2"));

var GLOBAL_DELEGATE = null;
var CACHE = {};

function setupDelegate() {
  if (!GLOBAL_DELEGATE) {
    GLOBAL_DELEGATE = new window.cordova.plugins.locationManager.Delegate();

    if (_DeviceInfoHelper["default"].isAndroid()) {
      GLOBAL_DELEGATE.didDetermineStateForRegion = function (pluginResult) {
        console.log('[Beacon] didDetermineStateForRegion:', pluginResult); // this is the best we get on Android

        var accuracy = pluginResult.state === 'CLRegionStateInside' ? 1 : -1;

        _DataStore["default"].setSingleData("private.beacons.".concat(pluginResult.region.identifier), accuracy, false);
      };
    }

    GLOBAL_DELEGATE.didStartMonitoringForRegion = function (pluginResult) {
      console.log('[Beacon] didStartMonitoringForRegion:', pluginResult);
    };

    if (_DeviceInfoHelper["default"].isiOS()) {
      GLOBAL_DELEGATE.didRangeBeaconsInRegion = function (pluginResult) {
        pluginResult.beacons.forEach(function (beacon) {
          if (CACHE[beacon.uuid]) {
            console.log("beacon accuracy of ".concat(CACHE[beacon.uuid].identifier, " -> ").concat(beacon.accuracy));

            _DataStore["default"].setSingleData("private.beacons.".concat(CACHE[beacon.uuid].identifier), beacon.accuracy, false);
          }
        });
      };
    }

    window.cordova.plugins.locationManager.setDelegate(GLOBAL_DELEGATE);
  }
}

var BeaconTracker = /*#__PURE__*/function () {
  function BeaconTracker(identifier, beaconUuid) {
    var beaconMajor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var beaconMinor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    (0, _classCallCheck2["default"])(this, BeaconTracker);
    this.identifier = identifier;
    this.uuid = beaconUuid;
    this.major = beaconMajor;
    this.minor = beaconMinor;

    if (!CACHE[beaconUuid]) {
      CACHE[beaconUuid] = new window.cordova.plugins.locationManager.BeaconRegion(this.identifier, this.uuid, this.major, this.minor);
    }

    this.beaconRegion = CACHE[beaconUuid];

    if (_DeviceInfoHelper["default"].isiOS()) {
      window.cordova.plugins.locationManager.requestWhenInUseAuthorization(); // window.cordova.plugins.locationManager.requestAlwaysAuthorization()
    }

    setupDelegate();
  }

  (0, _createClass2["default"])(BeaconTracker, [{
    key: "startMonitoring",
    value: function startMonitoring() {
      console.log("[Beacon] start monitoring beacon ".concat(this.identifier));
      window.cordova.plugins.locationManager.startMonitoringForRegion(this.beaconRegion).fail(function (e) {
        console.error(e);
      }).done();
    }
  }, {
    key: "stopMonitoring",
    value: function stopMonitoring() {
      console.log("[Beacon] stop monitoring beacon ".concat(this.identifier));
      window.cordova.plugins.locationManager.stopMonitoringForRegion(this.beaconRegion).fail(function (e) {
        console.error(e);
      }).done();
    }
  }, {
    key: "startRanging",
    value: function startRanging() {
      console.log("[Beacon] start ranging beacon ".concat(this.identifier));
      window.cordova.plugins.locationManager.startRangingBeaconsInRegion(this.beaconRegion).fail(function (e) {
        console.error(e);
      }).done();
    }
  }, {
    key: "stopRanging",
    value: function stopRanging() {
      console.log("[Beacon] stop ranging beacon ".concat(this.identifier));
      window.cordova.plugins.locationManager.stopRangingBeaconsInRegion(this.beaconRegion).fail(function (e) {
        console.error(e);
      }).done();
    }
  }]);
  return BeaconTracker;
}();

BeaconTracker.isBeaconTrackingAvailable = function () {
  return !_DeviceInfoHelper["default"].isBrowser() && window.cordova.plugins && window.cordova.plugins.locationManager && window.cordova.plugins.locationManager.BeaconRegion;
};

var _default = BeaconTracker;
exports["default"] = _default;